import React from 'react'
import SwitchElement from '../../../../../../../components/elements/toggles/toggles/SwitchElement'

type ExportOptionProps = {
  iconSrc: string
  iconAlt?: string
  title: string
  description: string
  enabled: boolean
  onToggle: (enabled: boolean) => void
}

const ExportOption: React.FC<ExportOptionProps> = ({
  iconSrc,
  iconAlt = 'Option icon',
  title,
  description,
  enabled,
  onToggle,
}) => {
  return (
    <div className="flex items-center justify-between py-3  ">
      <div className="flex items-start">
        <div className="mr-3 flex-shrink-0 w-10 h-10 ">
          <img src={iconSrc} alt={iconAlt} className="w-full h-full object-contain" />
        </div>
        <div>
          <h3 className="text-SeabiscuitDark200ThemeColor/60 text-nr">{title}</h3>
          <p className="text-SeabiscuitDark200ThemeColor text-sm mt-1">{description}</p>
        </div>
      </div>
      <div className="ml-4">
        <SwitchElement on={enabled} onSwitch={onToggle} buttonClassName="small" />
      </div>
    </div>
  )
}

export default ExportOption
